import TabbedNavigation from 'common/components/tabbed_navigation';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';

const mapStateToProps = (state, { params, router }) => {
  const { subcategory, pageSlug, presentationId, revisionId  } = params;
  const urlBase = (
    `/${subcategory}/${pageSlug}/presentations/${presentationId}/results/${revisionId}`
  );

  const tabs = {
    links: [
      {
        url: `${urlBase}/comments`,
        name: 'comments',
      },
      {
        url: `${urlBase}/votes`,
        name: 'votes',
      },
    ]
  };

  return {
    projectUrl: params.projectUrl || '',
    tabs,
    router,
  };
}

export default withRouter(connect(mapStateToProps, { push })(TabbedNavigation));



// WEBPACK FOOTER //
// ./presentations/containers/revision_results_tabs.js